import React from 'react';
import { Modals, ModalsType } from '../../modules/dialogs/model';
import ActivateDialog from '../dialogs/activateDialog';
import RemoveDialog from '../dialogs/removeDialog';
import SearchViaFileDialog from '../dialogs/searchFileDialog';
import SettingsDialog from './datatable/settingsDialog';
import ReadRightsAssignDialog from '../dialogs/readRightAssignDialog';
import HelloWorldDialog from '../dialogs/HelloWorldDialog';
import ModalDialog from './modalDialog';
import useModal from '../../hooks/useModal';
import { DialogBox } from './dialog/context';
import TxDialogDevices from '../dialogs/transfer/txDialogDevices';

interface OwnProps {
  activeModal: ModalsType;
}

type Props = OwnProps;

const ModalSelector: React.FC<Props> = (props) => {
  const { setModal: setDialog } = useModal();

  let selectedModal = undefined;
  let id = 'no-modal';
  const modalId = props.activeModal as Modals;
  if (modalId) {
    switch (modalId) {
      case Modals.DEVICE_ACTIVATE:
        id = 'modal_activate';
        selectedModal = <ActivateDialog />;
        break;
      case Modals.DEVICE_REMOVE:
        id = 'modal_remove';
        selectedModal = <RemoveDialog />;
        break;
      case Modals.DEVICE_SEARCHFILE:
        id = 'modal_search_via_file';
        selectedModal = <SearchViaFileDialog />;
        break;
      case Modals.TABLE_SETTINGS:
        return <SettingsDialog />;
      case Modals.DEVICE_READRIGHTS_ASSIGN:
        id = 'readrights_dialog';
        selectedModal = <ReadRightsAssignDialog />;
        break;
      case Modals.HELLO_WORLD:
        id = 'modal_helloworld';
        selectedModal = <HelloWorldDialog />;
        break;
      case Modals.TRANSFER_DEVICES:
          id = 'modal_transferDefices';
          selectedModal = <TxDialogDevices />;
          break;
      default:
        break;
    }
  }
  return selectedModal ? (
    <ModalDialog title="" body={[]} classes={id}>
      <DialogBox value={{ dialogId: modalId, setDialog }}>
        {selectedModal}
      </DialogBox>
    </ModalDialog>
  ) : (
    <></>
  );
};

export default ModalSelector;
